import { Link, NavLink, Outlet } from "react-router-dom";
import { ArrowRight, FlaskConical } from "lucide-react";
import { Logo } from "../../components/Logo";

const TABS = [["/demo", "Sample team", true], ["/demo/players/demo-p1", "Sample player report"], ["/demo/recruiter", "Sample recruiter board"], ["/visibility", "Who sees what"]];

export default function DemoLayout() {
  return (
    <div className="min-h-screen bg-[#0A0E1A] text-slate-100" data-testid="demo-layout">
      <header className="sticky top-0 z-40 border-b border-white/5 bg-[#0A0E1A]/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-3 px-5 py-3 sm:px-10">
          <Logo />
          <div className="flex items-center gap-2">
            <Link to="/login" data-testid="demo-login-button" className="rounded-full border border-white/15 px-4 py-2 text-sm font-semibold text-white hover:border-[#39FF14]/60">Log in</Link>
            <Link to="/join" data-testid="demo-join-button" className="group inline-flex items-center gap-1.5 rounded-full bg-[#39FF14] px-4 py-2 text-sm font-bold text-[#0A0E1A] hover:shadow-[0_0_30px_rgba(57,255,20,0.45)]">
              Create your team <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </div>
        </div>
        <div data-testid="demo-banner" className="border-t border-[#39FF14]/20 bg-[#39FF14]/10">
          <div className="mx-auto flex max-w-[1400px] flex-wrap items-center gap-x-5 gap-y-2 px-5 py-2.5 sm:px-10">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#39FF14] px-3 py-1 font-mono-gd text-[11px] font-bold uppercase tracking-wider text-[#0A0E1A]"><FlaskConical className="h-3.5 w-3.5" />Sample data</span>
            <p className="text-sm text-slate-200">You're exploring a made-up team. Every name and number here is fictional. Nothing you click changes real data.</p>
          </div>
        </div>
        <nav className="mx-auto flex max-w-[1400px] gap-1 overflow-x-auto px-5 py-2 sm:px-10">
          {TABS.map(([to, label, end]) => (
            <NavLink key={to} to={to} end={end} data-testid={`demo-tab-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${isActive ? "bg-white/10 text-white" : "text-slate-400 hover:text-white"}`}>{label}</NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-[1400px] px-5 py-8 sm:px-10 sm:py-10"><Outlet /></main>
      <section className="border-t border-white/5">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-4 px-5 py-10 sm:flex-row sm:items-center sm:justify-between sm:px-10">
          <div>
            <p className="font-display text-3xl font-black uppercase text-white">Your team, with your numbers.</p>
            <p className="mt-1 text-slate-400">Same login as the GAMEDAY mobile app. Coaches get a 14-day free trial.</p>
          </div>
          <Link to="/join" data-testid="demo-bottom-join" className="inline-flex items-center gap-2 self-start rounded-full bg-[#39FF14] px-6 py-3 font-bold text-[#0A0E1A]">Start with your team <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}
